import qs from 'qs';
import request from '@/config/request';

/*
  获取品牌列表
  brandName
*/
export function getBrandList({ page, pageSize, ...rest }) {
  return request({
    url: `/brand/getBrandList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取店铺列表
*/
export function getShopList() {
  return request({
    url: '/brand/getShopList',
    method: 'post',
  });
}

/*
  添加品牌
  brandName, brandNameEnglish，brandCountry，brandDetail，brandUrl
*/
export function addBrand(rest) {
  return request({
    url: '/brand/addBrand',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  删除品牌
  id
*/
export function deleteBrand(id) {
  return request({
    url: '/brand/deleteBrand',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  获取品牌详情
  id
*/
export function getBrand(id) {
  return request({
    url: '/brand/getBrand',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  编辑品牌
  id，brandName, brandNameEnglish，brandCountry，brandDetail，brandUrl
*/
export function updateBrand(rest) {
  return request({
    url: '/brand/updateBrand',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  批量上下架
  ids，brandState
*/
export function updateBrandUpAndDown(ids, brandState) {
  return request({
    url: '/brand/updateBrandUpAndDown',
    method: 'post',
    data: qs.stringify({
      ids,
      brandState,
    }),
  });
}
